import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  padding-bottom: 20px;
  :last-child {
    border: 0;
  }
`;

export const SettingsRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 0px 20px 0px 20px;
`;

export const SettingsRecap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
`;

export const SubOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SettingsName = styled.label`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: 16px;
  font-weight: 500;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const SettingsDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 4px 0px 0px 0px;
`;

export const Header = styled.div`
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding-bottom: 16px;
  padding-left: 16px;

  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
  }
  p {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
`;
